import qs from "qs";
import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

const axiosBase = new AxiosBase();
const $axios = Axios.http;

const state = {
  importWorkToken: null,
  errorOnly: false,
  workResultList: [], // Import結果のリスト
  workList: [], // Excelのデータ
  workListAllCount: 0,
  workListErrorCount: 0,
  noWorkImportRow: false
};

const getters = {
  workListAllCount: () => state.workListAllCount,
  workListErrorCount: () => state.workListErrorCount,
  noWorkImportRow: () => state.noWorkImportRow,
  errorOnly: () => state.errorOnly,
  canImport: () => {
    return getters.workListErrorCount() === 0;
  },
  isAnyCheckImportTarget: () => {
    return state.workList.filter(element => element.importTarget).length > 0;
  }
};

const actions = {
  async fetchClearWorkList() {},
  async fetchManualOrderImportWorkCount({ commit, state }) {
    if (state.importWorkToken === null) {
      return null;
    }
    return $axios
      .get(axiosBase.getUrls().manualOrderImportWorkListCount, {
        params: { ...{ token: state.importWorkToken } }
      })
      .then(value => {
        commit("writeWorkCount", value.data.data);
        return Promise.resolve(value.data.data == null ? [] : value.data.data);
      });
  },
  async toggleManualOrderImportErrorOnly({ commit }, toggle) {
    commit("writeImportWorkErrorOnly", toggle);
  },
  async writeToken({ commit, state }, token) {
    commit("writeImportWorkToken", token);
  },
  async fetchAllOrderImportWork({ commit, state }, getParams) {
    if (state.importWorkToken === null) {
      return null;
    }
    let pageCount = getParams.pageCount;
    const setParams = {
      token: state.importWorkToken,
      pageCount: getParams.pageCount,
      errorOnly: state.errorOnly
    };
    return $axios
      .get(axiosBase.getUrls().manualOrderImportWorkList, {
        params: setParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
      .then(value => {
        commit("clearWorkResultList");
        if (pageCount === 0) {
          commit("clearWorkList");
        }
        commit("writeWorkList", value.data.data);
        if (state.workList.length < 1) {
          commit("writeWorkImportRow", true);
        } else {
          commit("writeWorkImportRow", false);
        }
        return Promise.resolve(value.data.data);
      })
      .catch(reason => {
        commit("writeImportWorkToken", "");
        return Promise.reject(reason);
      });
  },
  async commitImportRequest({ dispatch, commit, state }, keyList) {
    const payLoad = {
      data: JSON.stringify({
        targetIdList: keyList,
        token: state.importWorkToken
      }),
      headers: {
        "Content-Type": "application/json"
      },
      uri: axiosBase.getUrls().manualOrderImportFileCommit
    };

    dispatch("indicator/indicate", payLoad, { root: true }).then(data => {
      commit("clearWorkList");
      commit("writeWorkResultList", JSON.parse(data));
      commit("writeImportWorkToken", null);
    });
  }
};

const mutations = {
  writeImportWorkToken(state, token) {
    state.importWorkToken = token;
  },
  writeWorkList(state, data) {
    if (data != null) {
      state.workList = state.workList.concat(data.list);
    }
  },
  writeWorkImportRow(state, data) {
    state.noWorkImportRow = data;
  },
  writeWorkResultList(state, data) {
    if (data != null) {
      state.workResultList = data;
    }
  },
  writeWorkCount(state, data) {
    state.workListAllCount = data.allCount;
    state.workListErrorCount = data.errorCount;
  },
  writeImportWorkErrorOnly(state, toggle) {
    state.errorOnly = toggle;
  },
  clearWorkResultList(state) {
    state.workResultList = [];
  },
  clearWorkAndResult(state) {
    state.workList = [];
    state.workResultList = [];
  },
  clearWorkList(state) {
    state.workList = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
